import api from './axios';
import { Product } from '../types/product';

export const productApi = {
  getProductDetails: async (productId: number): Promise<Product> => {
    try {
      const response = await api.get(`/api/shop/products/${productId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product details:', error);
      throw error;
    }
  },
};
